import { addClass, removeClass, hasClass, fadeIn, fadeOut } from './lib/util';

//ドロップダウンメニュー アクセシビリティ対応
$('.menu-item-has-children a').focus( function () {
	$(this).siblings('.sub-menu').addClass('focused');
}).blur(function(){
	$(this).siblings('.sub-menu').removeClass('focused');
});

$('.sub-menu a').focus( function () {
	$(this).parents('.sub-menu').addClass('focused');
}).blur(function(){
	$(this).parents('.sub-menu').removeClass('focused');
});

//toggle panel
const toggleBtn = $(".js-toggle");
toggleBtn.on("click", function () {
	$(this).toggleClass("is-open");
	$(this).next().slideToggle();
});

// global menu for SP
const menuBtn = document.querySelector('#js-menu');
const menuPanel = document.querySelector('#js-gnav');
menuBtn.addEventListener('click', () => {
	if (hasClass(menuBtn, 'is-open')) {
		removeClass(menuBtn, 'is-open');
		menuBtn.setAttribute('aria-expanded', 'false');
		menuBtn.setAttribute('aria-label', 'メニューを開く');
		menuPanel.setAttribute('aria-hidden', 'true');
		fadeOut(menuPanel);
	} else {
		addClass(menuBtn, 'is-open');
		menuBtn.setAttribute('aria-expanded', 'true');
		menuBtn.setAttribute('aria-label', 'メニューを閉じる');
		menuPanel.setAttribute('aria-hidden', 'false');
		fadeIn(menuPanel);
	}
});

//smooth scroll
const smoothScrollTriggers = document.querySelectorAll('a[href^="#"]');
const offset = document.getElementById('js-header').clientHeight + 30;

smoothScrollTriggers.forEach(function (smoothScrollTrigger) {
	smoothScrollTrigger.addEventListener('click', function (e) {
		const href = smoothScrollTrigger.getAttribute('href');
		const targetElement = (href === "#") ? document.getElementsByTagName('html')[0] : document.getElementById(href.replace('#', ''));
		if (targetElement) {
			e.preventDefault();
			e.stopPropagation();
			const targetPosition = window.pageYOffset + targetElement.getBoundingClientRect().top - offset;
			window.scroll({
				top: targetPosition,
				behavior: 'smooth'
			});
		}
	});
});

//back to page top button
let scrollPx = window.pageYOffset
const topBtn = document.getElementById('js-pagetop');

window.addEventListener('scroll',
	() => {
		scrollPx = window.pageYOffset

		if (scrollPx > 300) {
			addClass(topBtn, 'is-scroll');
		} else {
			removeClass(topBtn, 'is-scroll');
		}
	}, {
	passive: true
	}
)
